module.exports = __webpack_public_path__ + "static/img/logo5.ece00d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/header/logo5.png
// module id = Tsek
// module chunks = 81